export default __webpack_public_path__ + "static/media/avatar_fairy_pixie3.7b6ee0de.mp3";